(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matching-set"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const topCarousel = document.getElementById('top-carousel');
    const bottomCarousel = document.getElementById('bottom-carousel');
    const topSizeSelect = document.getElementById('top-size');
    const bottomSizeSelect = document.getElementById('bottom-size');
    const totalPriceElement = document.getElementById('total-price');

    // Center the active item in the carousel
    function centerActiveItem(carousel) {
      const activeItem = carousel.querySelector('.matching-set__item--active');
      if (!activeItem) return;

      const carouselWidth = carousel.offsetWidth;
      const itemWidth = activeItem.offsetWidth;
      const itemOffsetLeft = activeItem.offsetLeft;
      const scrollPosition = itemOffsetLeft - (carouselWidth / 2) + (itemWidth / 2);

      carousel.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }

    // Populate size selector with variant sizes
    function populateSizeSelector(selectElement, variants) {
      selectElement.innerHTML = '';
      
      const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
      
      const sizes = [...new Set(variants.map(v => v.option1).filter(size => size))]
        .sort((a, b) => {
          const aIndex = sizeOrder.indexOf(a);
          const bIndex = sizeOrder.indexOf(b);
          if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
          if (aIndex === -1) return 1;
          if (bIndex === -1) return -1;
          return aIndex - bIndex;
        });

      sizes.forEach(size => {
        const variant = variants.find(v => v.option1 === size);

        if (variant) {
          const option = document.createElement('option');
          option.value = size;
          option.dataset.variantId = variant.id; // Add data-variant-id attribute

          // Check availability
          if (!variant.available) {
            option.textContent = `${size} - Sold Out`;
            option.disabled = true;
          } else {
            option.textContent = size;
          }

          // Default to M if available and not sold out
          if (size === 'M' && variant.available) {
            option.selected = true;
          }

          selectElement.appendChild(option);
        }
      });
    }

    // Find the first variant for a given size (default color)
    function findFirstVariantForSize(variants, size) {
  return variants.find(v => v.option1 === size && v.available);
}

    // Update set total price
    async function updateSetTotal() {
      const activeTop = topCarousel.querySelector('.matching-set__item--active');
      const activeBottom = bottomCarousel.querySelector('.matching-set__item--active');
      let topPrice = 0;
      let bottomPrice = 0;

      if (activeTop) {
        const variants = JSON.parse(activeTop.dataset.variants);
        const size = topSizeSelect.value;
        const variant = findFirstVariantForSize(variants, size);
        topPrice = variant ? variant.price / 100 : 0;
      }

      if (activeBottom) {
        const variants = JSON.parse(activeBottom.dataset.variants);
        const size = bottomSizeSelect.value;
        const variant = findFirstVariantForSize(variants, size);
        bottomPrice = variant ? variant.price / 100 : 0;
      }

      const total = (topPrice + bottomPrice).toFixed(2);
      totalPriceElement.textContent = total;
    }

    // Scroll carousel by a fixed amount
    window.scrollCarousel = (carouselId, amount) => {
      const carousel = document.getElementById(carouselId);
      carousel.scrollBy({
        left: amount,
        behavior: 'smooth'
      });
    };

    // Initialize carousels and size selectors
    function initializeCarousels() {
      const firstTop = topCarousel.querySelector('.matching-set__item:first-child');
      const firstBottom = bottomCarousel.querySelector('.matching-set__item:first-child');

      if (firstTop) {
        firstTop.classList.remove('matching-set__item--inactive');
        firstTop.classList.add('matching-set__item--active');
        const topVariants = JSON.parse(firstTop.dataset.variants);
        populateSizeSelector(topSizeSelect, topVariants);
        topSizeSelect.dataset.productId = firstTop.dataset.productId;
        setTimeout(() => centerActiveItem(topCarousel), 0);
      }

      if (firstBottom) {
        firstBottom.classList.remove('matching-set__item--inactive');
        firstBottom.classList.add('matching-set__item--active');
        const bottomVariants = JSON.parse(firstBottom.dataset.variants);
        populateSizeSelector(bottomSizeSelect, bottomVariants);
        bottomSizeSelect.dataset.productId = firstBottom.dataset.productId;
        setTimeout(() => centerActiveItem(bottomCarousel), 0);
      }

      updateSetTotal();
    }

    // Carousel item click handler
    function setupCarousel(carousel, sizeSelect) {
      carousel.addEventListener('click', async (e) => {
        const item = e.target.closest('.matching-set__item');
        if (!item) return;

        // Remove active class from all items in this carousel
        carousel.querySelectorAll('.matching-set__item').forEach(i => {
          i.classList.remove('matching-set__item--active');
          i.classList.add('matching-set__item--inactive');
        });

        // Add active class to clicked item
        item.classList.remove('matching-set__item--inactive');
        item.classList.add('matching-set__item--active');

        // Update size selector
        const variants = JSON.parse(item.dataset.variants);
        populateSizeSelector(sizeSelect, variants);
        sizeSelect.dataset.productId = item.dataset.productId;

        // Center the active item
        centerActiveItem(carousel);
        await updateSetTotal();
      });
    }

    // Handle size selector changes
    topSizeSelect.addEventListener('change', updateSetTotal);
    bottomSizeSelect.addEventListener('change', updateSetTotal);

    initializeCarousels();
    setupCarousel(topCarousel, topSizeSelect);
    setupCarousel(bottomCarousel, bottomSizeSelect);

    // Handle window resize to keep active item centered
    window.addEventListener('resize', () => {
      centerActiveItem(topCarousel);
      centerActiveItem(bottomCarousel);
    });

    // Fetch product variants
    async function fetchVariants(productId) {
      try {
        const response = await fetch(`/products/${productId}.js`);
        if (!response.ok) throw new Error('Failed to fetch product');
        const product = await response.json();
        return product.variants;
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    // Get variant ID based on size (first matching color)
    function getVariantId(variants, size) {
      const variant = findFirstVariantForSize(variants, size);
      return variant ? variant.id : null;
    }

    // Add to cart
    async function addToCart(items) {
      const formData = {
        items: items
          .filter(item => item.id)
          .map(item => ({
            id: item.id,
            quantity: 1  // Support dynamic quantity, default to 1
          }))
      };

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (response.ok) {
          window.upcartOpenCart();
        } else {
          const errorData = await response.json();
          alert(errorData.description || 'Error adding to cart');
        }
      } catch (error) {
        console.error('Add to Cart Error:', error);
        alert('Unexpected error adding to cart');
      }
    }


    // Buy functions
    window.buyTopOnly = async () => {
      const activeTop = topCarousel.querySelector('.matching-set__item--active');
      if (!activeTop) {
        alert('No top product selected');
        return;
      }

      const selectedOption = topSizeSelect.options[topSizeSelect.selectedIndex];
      const variantId = selectedOption.dataset.variantId;

      if (variantId) {
        await addToCart([{ id: parseInt(variantId, 10) }]);
      } else {
        alert('Selected size not available for top');
      }
    };

    window.buyBottomOnly = async () => {
      const activeBottom = bottomCarousel.querySelector('.matching-set__item--active');
      if (!activeBottom) {
        alert('No bottom product selected');
        return;
      }

      const selectedOption = bottomSizeSelect.options[bottomSizeSelect.selectedIndex];
      const variantId = selectedOption.dataset.variantId;

      if (variantId) {
        await addToCart([{ id: parseInt(variantId, 10) }]);
      } else {
        alert('Selected size not available for bottom');
      }
    };

    window.buySet = async () => {
      const activeTop = topCarousel.querySelector('.matching-set__item--active');
      const activeBottom = bottomCarousel.querySelector('.matching-set__item--active');

      if (!activeTop || !activeBottom) {
        alert('Please select both a top and bottom product');
        return;
      }

      const topSelectedOption = topSizeSelect.options[topSizeSelect.selectedIndex];
      const bottomSelectedOption = bottomSizeSelect.options[bottomSizeSelect.selectedIndex];

      const topVariantId = topSelectedOption.dataset.variantId;
      const bottomVariantId = bottomSelectedOption.dataset.variantId;

      const items = [];
      if (topVariantId) items.push({ id: parseInt(topVariantId, 10) });
      if (bottomVariantId) items.push({ id: parseInt(bottomVariantId, 10) });

      if (items.length > 0) {
        await addToCart(items);
      } else {
        alert('That size is sold out in this style — try another combo 🤍');
      }
    };

  });

  } catch(e) { console.error(e); }
})();
})();
